import { AllTypeResourceItem } from "@/store/resources-grid/utils/types/resources";
import { AccountLight } from "@/services/cloudchipr.api";

export const getUniqueAccountFromResources = (
  resources: (AllTypeResourceItem | undefined)[],
) => {
  return Array.from(
    new Set(
      resources.map((resource) => {
        return (
          resource && "account" in resource ? resource?.account : undefined
        ) as AccountLight;
      }),
    ),
  );
};
